import React, { createContext, useContext, useState, useEffect } from "react";

const ServerIPContext = createContext();

export const ServerIPProvider = ({ children }) => {
    const hostname = window.location.hostname;
    const isDev = hostname === "dev.justifyai.app" || hostname === "localhost";

    // Default IPs
    const defaultIPs = {
        SERVER_IP: "https://54.211.242.51.nip.io",
        SERVER_IP_MULTIDOC: "https://54.211.242.51.nip.io",
        SERVER_IP_VIDEO: "https://54.211.242.51.nip.io",
        SERVER_IP_SOCKET: "https://54.211.242.51.nip.io",
    };

    // Load persisted values from localStorage
    const getPersistedIPs = () => {
        const hostname = window.location.hostname;
        const isDevHere = hostname === "dev.justifyai.app" || hostname === "localhost";

        if (isDevHere) {
            const savedIPs = localStorage.getItem("serverIPs");
            return savedIPs ? JSON.parse(savedIPs) : defaultIPs;
        }

        return defaultIPs;
    };

    const [serverIPs, setServerIPs] = useState(getPersistedIPs);

    useEffect(() => {
        localStorage.setItem("serverIPs", JSON.stringify(serverIPs));
    }, [serverIPs]);

    return (
        <ServerIPContext.Provider value={{ serverIPs, setServerIPs, isDev }}>
            {children}
        </ServerIPContext.Provider>
    );
};

export const useServerIP = () => useContext(ServerIPContext);
